// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { ARTICULO_FIELDS_FRAGMENT } from '../interfaces/fragments'
import { ArticuloApiInputProps, ArticuloProps } from '../../../interfaces/articulo.ts'

const query = gql`
  ${ARTICULO_FIELDS_FRAGMENT}
  mutation articuloActualizar(
    $cds: Int!
    $codigoArticulo: String!
    $input: ArticuloActualizarInput!
  ) {
    articuloActualizar(cds: $cds, codigoArticulo: $codigoArticulo, input: $input) {
      ...ArticuloFieldsFragment
    }
  }
`

/**
 * Actualizamos los datos de un articulo
 * @param cds
 * @param codigoArticulo
 * @param input
 */
export const apiArticuloActualizar = async (
  cds: number,
  codigoArticulo: string,
  input: ArticuloApiInputProps,
): Promise<ArticuloProps> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)

    const data: any = await client.request(query, { cds, codigoArticulo, input })
    return data.articuloActualizar
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
